module.exports = __webpack_public_path__ + "img/logo.4eddee58.png";